exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#btn-dropdown-themeSelection {\n  background-color: #1594A6;\n  display: block; }\n\n.icon-position {\n  padding-top: 5px; }\n\n.alert {\n  background-color: transparent !important; }\n\n#riskIndicatorsTitle {\n  font-size: 1.5em;\n  margin-bottom: 1em; }\n\n#date {\n  text-align: right;\n  line-height: 38px;\n  color: #9e9e9e; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/retrospective-wizard-1-start/retrospective-wizard-1-start.component.scss
// module id = ../../../../../src/app/components/retrospective-wizard-1-start/retrospective-wizard-1-start.component.scss
// module chunks = main